<template lang="pug">
  div
    span(v-if="!isEditing") {{ value }}
    span(v-else)
      v-text-field.editable-text(
        ref="editableText"
        :value.sync="value"
        outline
        single-line
        :rules="rules"
        @input="handleInput"
        @update:error="handleError"
      )
</template>

<script>
export default {
  name: 'EditableTextField',
  props: {
    value: String,
    isEditing: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    // error ref: https://github.com/vuetifyjs/vuetify/issues/12805 (apply on 1.5)
    // we need to validate the default value and tell the component that this call
    // is a forced call
    if (this.isEditing) {
      this.$refs.editableText.validate(true);
    }
    
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
    handleError(value) {
      this.$emit('update:error', value);
    },
  },
}
</script>

<style lang="scss" scoped>
.editable-text {
  /deep/ .v-input__slot {
    min-height: auto;
  }

  /deep/ input {
    padding: 10px 0;
    margin: 0;
  }
}
</style>
